import type { Direction } from "../direction";
import type { PointsToDirection } from "../interfaces";
import type { XY } from "../xy";
import { Timing } from "./effect";
import { XYEffect } from "./xyEffect";

export class DirectionalSlash3Tile extends XYEffect implements PointsToDirection {
	static key = "DirectionalSlash3Tile";
	private direction: Direction;

	constructor(xy: XY, direction: Direction) {
		super(xy);
		this.direction = direction;
		this.setTiming(Timing.BEFORE_STATE_UPDATE);
		this.setUnbounded(true);
	}

	getDirection(): Direction {
		return this.direction;
	}

	setDirection(dir: Direction): void {
		this.direction = dir;
	}
}
